import React, { Component } from 'react';
const chars = 'абвгдеёжзийклмнопрстуфхцчшщъыьэюя'.split('').concat('.', '-', ' ');

class Airport extends Component {

  state = {
    letters: new Array(this.props.text.length).fill(''),
  }

  textRef = (c) => this.text = c

  componentDidMount () {
    this.testChar(0,0,0,0,)
  }

  testChar = (a,b,c,d) => {
    const { letters } = this.state

    if(d >= letters.length) {
      console.log('finish')
    }
      //setTimeout(() => { this.testChar(0,0,c+1,0); }, 1000);
    else {
      letters[a] = chars[b]
      this.setState({letters: letters})

      setTimeout(() => {
        if(b > chars.length)
          this.testChar(a+1,0,c,d+1);
        else if(chars[b] !== this.props.text.substring(d,d+1).toLowerCase())
          this.testChar(a,b+1,c,d);
        else
          this.testChar(a+1,0,c,d+1);
      }, 10);
    }
  }

  render () {
    const { letters } = this.state
    return (
      <div ref={this.textRef} >
        <div>{letters.map((letter, index) => <span key={index} className={`${letter === '.' ? 'text-red': ''}`}>{letter}</span>)}</div>
      </div>
    )
  }
}

export default Airport


// WEBPACK FOOTER //
// ./src/components/airport/airport.js